module.exports = __webpack_public_path__ + "img/qpay.82b9c2ec.png";